import { isArray } from 'lodash';
import moment from 'moment';
import { TimeoffResponse } from 'api/timeoff/types';
import { humaniseWithDay, humanise } from 'components/atoms/humanised-date';
import { TimeOffEvent } from '../../event-types';

export const timeOffTemplate = ({ id }: Pick<TimeOffEvent, 'id'>): string => {
  return `<div class="content" data-event-id=${id}>`;
};

const getSingleTimeOffDetails = ({
  timeOffStart,
  timeOffEnd,
  note,
}: Pick<TimeoffResponse, 'timeOffEnd' | 'timeOffStart' | 'note'>) => {
  let content = '';

  if (timeOffStart === timeOffEnd) {
    content = `<br><div><strong>${humaniseWithDay(
      moment(timeOffStart),
    )}</strong></div>`;
    if (note) {
      content = content.concat(`<div><i>"${note}"</i></div>`);
    }
  } else {
    content = `<br><div><strong>${humanise(
      moment(timeOffStart),
    )}</strong> to <strong>${humanise(moment(timeOffEnd))}</strong></div>`;
    if (note) {
      content = content.concat(`<div><i>"${note}"</i></div>`);
    }
  }

  return content;
};

export const timeoffTooltip = ({
  userName,
  timeOff,
}: {
  userName: string;
  timeOff: TimeoffResponse[] | TimeoffResponse;
}): string => {
  let heading = `<div><strong>${userName}</strong> has applied for time off on:</div>`;

  if (isArray(timeOff)) {
    timeOff.forEach((timeOffT) => {
      const content = getSingleTimeOffDetails(timeOffT);

      heading = heading.concat(content);
    });
  } else {
    const content = getSingleTimeOffDetails(timeOff);

    heading = heading.concat(content);
  }

  return heading;
};
